/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RevokeDeviceTokenQuery model module.
 * @module model/RevokeDeviceTokenQuery
 * @version 0.0.1
 */
class RevokeDeviceTokenQuery {
    /**
     * Constructs a new <code>RevokeDeviceTokenQuery</code>.
     * @alias module:model/RevokeDeviceTokenQuery
     */
    constructor() { 
        
        RevokeDeviceTokenQuery.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RevokeDeviceTokenQuery</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RevokeDeviceTokenQuery} obj Optional instance to populate.
     * @return {module:model/RevokeDeviceTokenQuery} The populated <code>RevokeDeviceTokenQuery</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RevokeDeviceTokenQuery();

            if (data.hasOwnProperty('tokenLongId')) {
                obj['tokenLongId'] = ApiClient.convertToType(data['tokenLongId'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RevokeDeviceTokenQuery</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RevokeDeviceTokenQuery</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['tokenLongId'] && !(typeof data['tokenLongId'] === 'string' || data['tokenLongId'] instanceof String)) {
            throw new Error("Expected the field `tokenLongId` to be a primitive type in the JSON string but got " + data['tokenLongId']);
        }

        return true;
    }


}



/**
 * @member {String} tokenLongId
 */
RevokeDeviceTokenQuery.prototype['tokenLongId'] = undefined;






export default RevokeDeviceTokenQuery;

